import Checkout from './Checkout';
import enhance from './CheckoutContainer';

export default enhance(Checkout);



// WEBPACK FOOTER //
// ./src/app/giftCard/Checkout/index.js